import React from "react";
import styles from "../styles/CreateChatbot.module.css";

export default function Main({ language, chatbot }) {
  return (
    <div
      style={{
        borderRadius: 12,
        width: "50vw",
        right: 0,
        margin: 20,
        padding: 20,
        height: "100vh",
        fontFamily: "Jost",
        fontWeight: 600,
        scrollbarWidth: "none",
        overflow: "scroll",
      }}
    >
      <h5 className={styles.header} style={{ color: "#000" }}>
        {chatbot.name}
        <br></br>
      </h5>
      <h5 className={styles.header} style={{ color: "#000" }}>
        {language === "en"
          ? `Messages left: ${chatbot.messages}`
          : `Сообщений осталось: ${chatbot.messages}`}
        <br></br>
      </h5>
    </div>
  );
}
